import { QUERY_RETRY_LIMIT } from '../config';
import { isRetryableError } from '../errors';

// One retry rule for every hook: network, timeout, 5xx and 429 get two more
// tries; the rest of 4xx (401, 403, 400 cursor invalid) never retry, because
// a retry cannot change the answer.
export function queryRetry(failureCount: number, error: unknown): boolean {
  return failureCount < QUERY_RETRY_LIMIT && isRetryableError(error);
}
